<template>
  <div class="page-content">
    <BaseTable
      :rows="courses"
      resource-name="Courses"
      @select="goToCourse"
    >
      <template #header>
        <th
          v-for="column of availableColumns"
          :key="column.id"
          class="th"
        >{{ column.id }}</th>
      </template>
      <template #default="{ row: course }">
        <component :is="tableCellComponent('Code')" v-if="columnAvailable('Code', availableColumns)">
          <NuxtLink
            :to="getCourseUrl(course)"
            :aria-label="`Link to ${course.code || course.subjectCode + course.courseNumber || ''} course`"
          >
            {{ course.code || course.subjectCode + course.courseNumber }}
          </NuxtLink>
        </component>
        <component :is="tableCellComponent('Name')" v-if="columnAvailable('Name', availableColumns)">
          {{ courseNameWithFallbacks(course) }}
        </component>
        <component :is="tableCellComponent('Description')" v-if="columnAvailable('Description', availableColumns)">
          {{ getShortDescription(course.description) }}
        </component>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import { ref } from '@nuxtjs/composition-api'
import { getShortDescription } from '@/utils/generalUtils'
import { columnAvailable } from '@/utils/customisableDepartmentPage'
import useCourses from '@/composables/useCourses'
import { courseNameWithFallbacks } from '@/utils/entityNames'
import useMeta from '@/composables/useMeta'

const DEFAULT_COLUMNS_ORDER = ['Code', 'Name', 'Description']

export default {
  props: {
    department: {
      type: Object,
      required: true,
    },
    courses: {
      type: Array,
      required: true,
    },
    availableColumns: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { root }) {
    const { goToCourse, getCourseUrl } = useCourses(root)
    const firstColumn = ref(DEFAULT_COLUMNS_ORDER[0])
    const { catalogWideMetaTitle } = useMeta()

    if (props.availableColumns.length) {
      firstColumn.value = props.availableColumns[0].id
    }

    return {
      getCourseUrl,
      goToCourse,
      firstColumn,
      courseNameWithFallbacks,
      catalogWideMetaTitle,
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department Courses | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Courses | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  methods: {
    getShortDescription,
    columnAvailable,
    tableCellComponent(column) {
      return column === this.firstColumn ? 'th' : 'td'
    },
  },
}
</script>
